/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ResetPasswordResponseDC } from '../models/reset-password-response-dc';
import { ResetPasswordRequestDC } from '../models/reset-password-request-dc';
@Injectable({
  providedIn: 'root',
})
class PasswordManagementService extends __BaseService {
  static readonly PasswordManagementResetPasswordPath = '/api/PasswordManagement/ResetPassword';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Required Permission: EditProfiles (117)
   * @param params The `PasswordManagementService.PasswordManagementResetPasswordParams` containing the following parameters:
   *
   * - `resetPasswordRequestDC`: Reset Password Request
   *
   * - `Authorization`: access token
   *
   * @return OK
   */
  PasswordManagementResetPasswordResponse(params: PasswordManagementService.PasswordManagementResetPasswordParams): __Observable<__StrictHttpResponse<ResetPasswordResponseDC>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.resetPasswordRequestDC;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/PasswordManagement/ResetPassword`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResetPasswordResponseDC>;
      })
    );
  }
  /**
   * Required Permission: EditProfiles (117)
   * @param params The `PasswordManagementService.PasswordManagementResetPasswordParams` containing the following parameters:
   *
   * - `resetPasswordRequestDC`: Reset Password Request
   *
   * - `Authorization`: access token
   *
   * @return OK
   */
  PasswordManagementResetPassword(params: PasswordManagementService.PasswordManagementResetPasswordParams): __Observable<ResetPasswordResponseDC> {
    return this.PasswordManagementResetPasswordResponse(params).pipe(
      __map(_r => _r.body as ResetPasswordResponseDC)
    );
  }
}

module PasswordManagementService {

  /**
   * Parameters for PasswordManagementResetPassword
   */
  export interface PasswordManagementResetPasswordParams {

    /**
     * Reset Password Request
     */
    resetPasswordRequestDC: ResetPasswordRequestDC;

    /**
     * access token
     */
    Authorization: string;
  }
}

export { PasswordManagementService }
